export enum ProjectTypeEnum {
  MIGRATION = 'MIGRATION',
  ORGANIZATION = 'ORGANIZATION',
  INFRASTRUCTURE = 'INFRASTRUCTURE',
  SOFTWARE_DEVELOPMENT = 'SOFTWARE_DEVELOPMENT'
}
